import { APICallV4Post } from 'reactApp/api/APICall';

export class AllDocumentsAccessRequestAPICallV4 extends APICallV4Post {
    _method = '/cloud/b2b/domain/subscription';
}
